import { Box } from "@drone-js/core";
import { PageLoader } from "apps/commons/components/PageLoader";
import { Header } from "apps/propertySelection/Header";
import { usePropertySelectionViewModelApi } from "apps/propertySelection/usePropertySelectionViewModelApi";
import { useUnfinishedPropertiesApi } from "apps/propertySelection/useUnfinishedPropertiesApi";
import { Outlet } from "react-router";

const Layout = () => {
    const { isLoading: isLoadingViewModel } = usePropertySelectionViewModelApi();
    const { isLoading: isLoadingUnfinishedProperty } = useUnfinishedPropertiesApi();

    if (isLoadingViewModel || isLoadingUnfinishedProperty) return <PageLoader />;

    return (
        <>
            <Header />
            <Box pb="64">
                <Box maxWidth="848px" mx="auto" px="16" pb="24">
                    <Outlet />
                </Box>
            </Box>
        </>
    );
};

export default Layout;
